export function extractGROEquipments(monitoringGroup) {
  let techTracker, modelTracker, locator, immobilizer = null
  let baitsData = {};
  
  if (!monitoringGroup) {
    return {
      techTracker,
      modelTracker,
      locator,
      immobilizer,
      baitsData,
    }
  }

  const { tecnologies, equipments, baits, locators, immobilizers } = monitoringGroup;
  if (tecnologies?.length === 1) {
    techTracker = tecnologies[0];
    if (techTracker) {
      modelTracker = equipments?.find(
        item => item?.tracker_id === techTracker?.id
      );
    }
  }

  if (baits?.length === 1) {
    for (let i = 1; i <= monitoringGroup.bait_quantity; i++) {
      baitsData[`bait${i}`] = baits[0];
    }
  }

  if (locators?.length === 1) {
    locator = monitoringGroup?.locators[0]
  }

  if (immobilizers?.length === 1) {
    immobilizer = monitoringGroup?.immobilizers[0]
  }

  return {
    techTracker,
    modelTracker,
    locator,
    immobilizer,
    baitsData,
  }
}